import type { Category, CategoryId } from "./api";

export const DEFAULT_CATEGORIES: Category[] = [
  { id: "food", label: "Food", emoji: "🍔", order: 0 },
  { id: "trans", label: "Transport", emoji: "🚌", order: 1 },
  { id: "bills", label: "Bills", emoji: "💡", order: 2 },
  { id: "shop", label: "Shopping", emoji: "🛍️", order: 3 },
  { id: "enter", label: "Entertainment", emoji: "🎬", order: 4 },
  { id: "health", label: "Health", emoji: "💊", order: 5 },
  { id: "other", label: "Other", emoji: "📦", order: 6 },
];

export const OTHER_CATEGORY_ID: CategoryId = "other";

export const catMap = (cats: Category[]): Record<string, Category> =>
  Object.fromEntries(cats.map((c) => [c.id, c]));

export const slugifyCategoryId = (label: string): string =>
  label
    .toLowerCase()
    .normalize("NFKD")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 32);

export const todayLocalISO = (): string => {
  const d = new Date();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}-${m}-${day}`;
};

export const fmt = (n: number): string =>
  "€" + n.toFixed(2).replace(/\.00$/, "");

export const fmtFull = (n: number): string => "€" + n.toFixed(2);

export const monthName = (d: Date): string =>
  d.toLocaleString("en-US", { month: "long", year: "numeric" });

export function daysLeftInMonth(d: Date): number {
  const last = new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
  return last - d.getDate() + 1;
}
